import { h } from 'preact';
// TODO: Implement color swatch filter component
// - Display color options as swatches
// - Handle color selection
// - Show selected state
// - Support hex color codes
// - Add accessibility features
export function ColorSwatch({ options, onChange }) {
    return (h("div", { class: "color-swatch-list" }, options.map(option => (h("button", { key: option.id, class: `color-swatch ${option.selected ? 'selected' : ''}`, style: { backgroundColor: option.value }, onClick: () => onChange(option.id), title: option.label })))));
}
